<template>
  <div
    :class="{
      'clickable-table-cell': hasConcessions(property, dateRange)
    }"
    @click="showConcessionsPopup"
  >
    <slot></slot>
    <q-menu v-if="hasConcessions(property, dateRange)" transition-duration="100">
      <q-banner class="no-padding block">
        <concessions-card :property="property" :date-range="dateRange" />
      </q-banner>
    </q-menu>
  </div>
</template>

<script lang="ts">
import ConcessionsCard from '@/components/PropertyReports/ConcessionsCard.vue'
import type { PropertyDetailsResponse } from 'common'
import { hasConcessions } from '@/utils'
import type { PropType } from 'vue'

export default {
  name: 'ShowConcessionsPopupTableCell',
  components: { ConcessionsCard },
  props: {
    dateRange: {
      type: Object as PropType<{ from: Date; to: Date }>,
      required: true
    },
    property: {
      type: Object as PropertyDetailsResponse,
      required: true
    }
  },
  methods: {
    hasConcessions,
    showConcessionsPopup() {
      if (hasConcessions(this.property, this.dateRange)) {
        this.$tracker.openedPopup('specials')
      }
    }
  }
}
</script>
